import React, { useState, useEffect } from "react";
import { all_routes } from "Router/all_routes";
import { Edit, Save, Trash2 } from "react-feather";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import ToastNotification from "Components/UI/ToastNotification";
import Input from "Components/UI/Input";
import { useForm, FormProvider, Controller } from "react-hook-form";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { useGetEmployeeLeaveQuery } from "AppQuries/leave/get-employee-leaves";
import Select from "react-select";
import { applyLeaveValidationSchema } from "core/Operations/ValidationSchema/leaveValidaitionSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  useApproveLeaveMutation,
  useRejectLeaveMutation,
  useSaveApplyLeaveMutation,
} from "AppQuries/leave/apply-leave";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import { checkIsPublicHoliday } from "core/Operations/attendance/checkPublicHoliday";
import { useGetPublicHolidaysQuery } from "AppQuries/leave/public-holiday/public-holiday";
import moment from "moment";
import { toast } from "core/Operations/toast";
import ImageUploader from "Components/UI/ImageUploder";
import ApplyLeaveDayDetails from "./ApplyLeave/ApplyLeaveDayDetails";
import { useGetEmpAppliedLeaveDetailsQuery } from "AppQuries/leave/applied-leave-detail";
import { Table } from "antd";
import Swal from "sweetalert2";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import ImageWithBasePath from "core/img/imagewithbasebath";
import ImageWithURL from "core/img/imagewithurl";
import ImagePreview from "Components/UI/Image/ImagePreview";
import { Document, Page, pdfjs } from "react-pdf";

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

const isPaidOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const isApprovedOption = [
  { id: 1, label: "Yes", value: 1 },
  { id: 0, label: "No", value: 0 },
];

const ViewApplyLeave = () => {
  const userData = useSelector(loggedInUser);
  const [numPages, setNumPages] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();
  const employeeCode = searchParams.get("employeeCode");
  const code = searchParams.get("code");

  const { data: employees } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  const { data: publicHolidays } = useGetPublicHolidaysQuery({
    companyCode: userData?.companyCode,
  });

  const { mutate: approveLeave } = useApproveLeaveMutation();
  const { mutate: rejectLeave } = useRejectLeaveMutation();

  const navigate = useNavigate();

  const employeeOptions =
    employees
      ?.filter((d) => d.isActive)
      ?.map((o) => ({
        id: o.employeeCode,
        label: `${o.uniqueId} - ${o.fullName}`,
        value: o.employeeCode,
      })) || [];

  const { data: leaveTypes } = useGetEmployeeLeaveQuery(
    {
      companyCode: userData?.companyCode,
      employeeCode,
      locationCode: userData?.locationCode,
    },
    { enabled: !!employeeCode },
  );

  const methods = useForm({
    resolver: yupResolver(applyLeaveValidationSchema),
    defaultValues: {
      companyCode: userData?.companyCode,
      headerID: 0,
      leaveCode: 0,
      leaveId: 0,
      includePublicHoliday: true,
      // isPaidLeave: true,
      // isApproved: 1,
      approvedBy: "",
      approvedDate: "",
      createUser: userData?.userName,
      locationCode: userData?.locationCode,
      details: [],
    },
  });
  const {
    setValue,
    watch,
    handleSubmit,
    trigger,
    getValues,
    control,
    formState: { errors },
  } = methods;

  const [employeeleaveTypes, setEmployeeLeaveTypes] = useState([]);
  //   const [leaveTypeOptions, setEmployeeLeaveOptions] = useState([
  //     {
  //       id: 0,
  //       label: "Select Leave",
  //       value: 0,
  //     },
  //   ]);

  const leaveTypeOptions =
    leaveTypes?.data?.map((o) => ({
      id: o.code,
      label: o.leaveName,
      value: o.leaveCode,
    })) || [];

  const {
    data: leaveDetails,
    refetch,
    isFetching,
    isLoading: isLeaveDetailsLoading,
  } = useGetEmpAppliedLeaveDetailsQuery({
    companyCode: userData?.companyCode,
    employeeCode: employeeCode,
    code: code,
  });

  const {
    mutate: applyLeave,
    isLoading,
    isPending,
    isError,
    error,
  } = useSaveApplyLeaveMutation();

  // const calculateLeaveDays = (startDate, endDate) => {
  //   const start = new Date(startDate);
  //   const end = new Date(endDate);
  //   let holidays = 0;
  //   const selectedEmployee = employees?.data?.find(
  //     (e) => e.employeeCode === watch("employeeCode")
  //   );

  //   if (!getValues("includePublicHoliday")) {
  //     const restData = selectedEmployee?.restDay?.split(",") || [];
  //     for (
  //       let date = new Date(start);
  //       date <= end;
  //       date.setDate(date.getDate() + 1)
  //     ) {
  //       const fullRestDay = restData
  //         .filter((v) => v.includes("-1"))
  //         .map((d) => d?.split("-")[0]);

  //       console.log("fullRestDay", fullRestDay);

  //       const halfRestDay = restData
  //         .filter((v) => v.includes("-0.5"))
  //         .map((d) => d?.split("-")[0]);

  //       const day = moment(date).format("dddd");

  //       const isRestDay =
  //         Array.isArray(fullRestDay) && fullRestDay.includes(day);
  //       const isHalfRestDay =
  //         Array.isArray(halfRestDay) && halfRestDay.includes(day);

  //       if (
  //         checkIsPublicHoliday(
  //           publicHolidays,
  //           format(new Date(date), "yyyy-MM-dd")
  //         ) ||
  //         isRestDay
  //       ) {
  //         holidays++;
  //       } else if (isHalfRestDay) {
  //         holidays = holidays + 0.5;
  //       }
  //     }
  //   }

  //   if (!isNaN(start) && !isNaN(end) && start <= end) {
  //     const difference = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;
  //     setValue("noOfDays", difference - holidays);

  //     if (difference > getValues("balanceLeave")) {
  //       setValue("isPaidLeave", false);
  //     } else {
  //       setValue("isPaidLeave", true);
  //     }
  //   } else {
  //     setValue("noOfDays", 0);
  //   }
  // };

  const calculateLeaveDays = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const selectedEmployee = employees?.find(
      (e) => e.employeeCode === watch("employeeCode"),
    );

    const validLeaveDates = [];

    console.log("selectedEmployee", selectedEmployee);

    if (!isNaN(start) && !isNaN(end) && start <= end) {
      const restData = selectedEmployee?.restDay?.split(",") || [];
      console.log("restData", restData);
      const fullRestDay = restData
        .filter((v) => v.includes("-1"))
        .map((d) => d?.split("-")[0]);
      const halfRestDay = restData
        .filter((v) => v.includes("-0.5"))
        .map((d) => d?.split("-")[0]);

      console.log("fullRestDay", fullRestDay);
      console.log("halfRestDay", halfRestDay);

      for (
        let date = new Date(start);
        date <= end;
        date.setDate(date.getDate() + 1)
      ) {
        const currentDate = new Date(date);
        const dayName = moment(currentDate).format("dddd");
        const formattedDate = format(currentDate, "yyyy-MM-dd");

        console.log("formattedDate", dayName);

        const isPublicHoliday = checkIsPublicHoliday(
          publicHolidays,
          formattedDate,
        );
        const isRestDay = fullRestDay.includes(dayName);
        const isHalfRestDay = halfRestDay.includes(dayName);

        if (
          (!getValues("includePublicHoliday") && isPublicHoliday) ||
          isRestDay
        ) {
          continue; // Skip full holidays/rest days
        }

        validLeaveDates.push({
          date: formattedDate,
          isHalfDay: false, // isHalfRestDay, // use when the half day feature is implemented
        });
      }

      const totalLeaveDays = validLeaveDates.reduce(
        (sum, d) => sum + (d.isHalfDay ? 0.5 : 1),
        0,
      );

      setValue("noOfDays", totalLeaveDays);
      setValue("selectedLeaveDates", validLeaveDates); // Store for useEffect

      setValue("isPaidLeave", totalLeaveDays <= getValues("balanceLeave"));
    } else {
      setValue("noOfDays", 0);
      setValue("selectedLeaveDates", []);
    }
  };
  const onSubmit = (payload) => {
    // if (payload.isApproved) {
    //   payload.approvedBy = userData?.userName;
    //   payload.approvedDate = getCurrentFormattedDate();
    // }
    console.log("payload", payload);
    applyLeave(payload, {
      onSuccess: (data) => {
        if (data[0].response === true) {
          toast.success(data[0].errorMessage || "Leave Applied Successfully.");
          setTimeout(() => {
            navigate(`${all_routes.leave}${all_routes.leave_manangement}`);
          }, 1000);
        } else {
          toast.warning(data[0].errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const selectEmployeeHandler = (e) => {
    console.log(e);
    const employeeCode = e;
    const selectedEmployee = employees?.data.find(
      (d) => d.employeeCode === employeeCode,
    );
    setValue("employeeCode", employeeCode);
    setValue("companyCode", selectedEmployee?.companyCode);
  };

  const selectLeaveHandler = (selectedOption) => {
    console.log("selectedOption", selectedOption);
    const selectedLeave =
      employeeleaveTypes.find((d) => d.leaveCode === selectedOption) || {};
    console.log(selectedLeave);
    setValue("leaveCode", selectedLeave.leaveCode || 0);
    setValue("totalLeaveDays", selectedLeave.totalLeaveDays || 0);
    setValue("allotedLeave", selectedLeave.noOfAllotedDays);
    setValue("prevNoOfDays", Number(selectedLeave.leaveTaken));
    setValue("balanceLeave", selectedLeave.balanceLeaveDays);
    setValue("noOfAppliedLeave", selectedLeave.noOfAppliedLeave);
    setValue("approvedLeaves", selectedLeave.approvedLeaves);
    setValue("pendingLeaves", selectedLeave.pendingLeaves);
    setValue("rejectedLeaves", selectedLeave.rejectedLeaves);
  };

  useEffect(() => {
    if (getValues("leaveFrom") && getValues("leaveTo"))
      calculateLeaveDays(getValues("leaveFrom"), getValues("leaveTo"));
  }, [watch("leaveFrom"), watch("leaveTo"), watch("includePublicHoliday")]);

  useEffect(() => {
    const selectedDates = watch("selectedLeaveDates") || [];

    if (watch("leaveCode") !== 0 && selectedDates.length > 0) {
      const leaveDetails = selectedDates.map((entry) => ({
        companyCode: watch("companyCode"),
        leaveId: 0,
        employeeCode: watch("employeeCode"),
        leaveFrom: entry.date,
        leaveTo: entry.date,
        noOfDays: entry.isHalfDay ? 0.5 : 1,
        isHalfDay: entry.isHalfDay,
        isPaidLeave: watch("balanceLeave") >= entry.isHalfDay ? true : false,
        isApproved: 0,
        approvedBy: "",
        approvedDate: "",
        enablePaidLeave: watch("balanceLeave") >= 1,
      }));

      setValue("details", leaveDetails);
      console.log("leaveDetails", leaveDetails);
    }
  }, [watch("selectedLeaveDates")]);
  const [isSettingData, setIsSettingData] = useState(false);
  useEffect(() => {
    setIsSettingData(true);
    if (leaveDetails) {
      Object.keys(leaveDetails[0]).forEach((key) => {
        setValue(key, leaveDetails[0][key]);
      });
    }
    setIsSettingData(false);
  }, [leaveDetails]);

  const confirmApprove = async (id) => {
    
    const selectedLeave = leaveDetails?.[0]?.details?.find(
      (d) => d.leaveId === id,
    );
    const existingLeaveType = selectedLeave?.isPaidLeave ? "paid" : "unpaid";

    const result = await Swal.fire({
      title: "Approve Leave",
      text: "Select leave type before approval",
      input: "radio",
      inputOptions: {
        paid: "Paid Leave",
        unpaid: "Unpaid Leave",
      },
      inputValidator: (value) => {
        if (!value) {
          return "Please select a leave type";
        }
      },
      inputValue: existingLeaveType,
      showCancelButton: true,
      confirmButtonText: "Continue",
    });
    console.log("Swal result", result?.value);
    if (!result.isConfirmed) return;

    Swal.fire({
      title: "Approve Leave?",
      text: "Are you sure to Approve this leave",
      type: "warning",
      showCancelButton: !0,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve it!",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn btn-danger ml-1",
      buttonsStyling: 1,
    }).then(function (t) {
      if (t.isConfirmed) {
        const payload = {
          companyCode: userData.companyCode,
          leaveId: id,
          isApproved: 1,
          isPaidLeave: result.value === "paid" ? true : false,
          approvedBy: userData.userName,
          approvedDate: format(new Date(), "yyyy-MM-dd"),
          modifyUser: userData.userName,
        };

        approveLeave(payload, {
          onSuccess: (data) => {
            if (data?.data[0].response === true) {
              refetch();
              Swal.fire({
                type: "success",
                title: "Leave Approved !",
                text: "Leave Approved Successfully..",
                confirmButtonClass: "btn btn-success",
              });
            } else {
              Swal.fire({
                title: "Warning!",
                text: data?.data[0].errorMessage,
                type: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
                confirmButtonClass: "btn btn-primary",
                okButtonClass: "",
                buttonsStyling: 1,
              });
            }
          },
          onError: (error) => {
            let message = error.message || "Something went wrong.";
            Swal.fire({
              title: "Warning!",
              text: message,
              type: "warning",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
              confirmButtonClass: "btn btn-primary",
              okButtonClass: "",
              buttonsStyling: 1,
            });
          },
        });
      }
    });
  };

  const confirmDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: !0,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn btn-danger ml-1",
    }).then(function (t) {
      if (t.isConfirmed) {
        const payload = {
          companyCode: userData.companyCode,
          leaveId: id,
          isPaidLeave: false,
          isApproved: 2,
          approvedBy: userData.userName,
          approvedDate: format(new Date(), "yyyy-MM-dd"),
          modifyUser: userData.userName,
        };

        approveLeave(payload, {
          onSuccess: (data) => {
            if (data?.data[0].response === true) {
              refetch();
              Swal.fire({
                type: "success",
                title: "Leave Deleted !",
                text: "Leave Deleted Successfully..",
                confirmButtonClass: "btn btn-success",
              });
            } else {
              Swal.fire({
                title: "Warning!",
                text: data?.data[0].errorMessage,
                type: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
                confirmButtonClass: "btn btn-primary",
                okButtonClass: "",
              });
            }
          },
          onError: (error) => {
            let message = error.message || "Something went wrong.";
            Swal.fire({
              title: "Warning!",
              text: message,
              type: "warning",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
              confirmButtonClass: "btn btn-primary",
              okButtonClass: "",
            });
          },
        });
      }
    });
  };

  const columns = [
    {
      title: "Leave From",
      dataIndex: "leaveFrom",
      key: "leaveFrom",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Leave To",
      dataIndex: "leaveTo",
      key: "leaveTo",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "No. of Days",
      dataIndex: "noOfDays",
      key: "noOfDays",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Paid Leave",
      dataIndex: "isPaidLeave",
      key: "isPaidLeave",
      render: (text) => <span>{text ? "Yes" : "No"}</span>,
    },
    {
      title: "Half Day",
      dataIndex: "isHalfDay",
      key: "isHalfDay",
      render: (text) => <span>{text ? "Yes" : "No"}</span>,
    },
    {
      title: "Status",
      dataIndex: "isApproved",
      key: "isApproved",
      render: (text) => (
        <span>
          {text === 0
            ? "Pending"
            : text === 1
              ? "Approved"
              : text === 2
                ? "Rejected"
                : ""}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "isApproved",
      //   className: "action-table-data",
      render: (text, record) => (
        <>
          {record?.isApproved === 0 && (
            <div className="text-center">
              <Link
                className="action-set"
                to="#"
                data-bs-toggle="dropdown"
                aria-expanded="true"
              >
                <i className="fa fa-ellipsis-v" aria-hidden="true" />
              </Link>

              <ul className="dropdown-menu">
                <li>
                  <button
                    type="button"
                    // to="#"
                    className="dropdown-item confirm-text"
                    onClick={(e) => confirmApprove(record.leaveId)}
                  >
                    <Edit className="me-2" />
                    Approve Leave
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    // to="#"
                    className="dropdown-item confirm-text"
                    onClick={(e) => confirmDelete(record.leaveId)}
                  >
                    <Trash2 className="me-2" />
                    Reject Leave
                  </button>
                </li>
              </ul>
            </div>
          )}
        </>
      ),
    },
  ];

  if (isLeaveDetailsLoading) return <LoadingSpinner />;

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <FormProvider {...methods}>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="needs-validation"
              noValidate=""
            >
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Apply Leave</h4>
                    <h6>Apply leave request for employees</h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="Back">Back</Tooltip>}
                  >
                    <button
                      className="btn btn-secondary me-md-2"
                      type="button"
                      //   disabled={isLoading}
                      onClick={() =>
                        navigate(
                          `${all_routes.leave}${all_routes.leave_manangement}`,
                        )
                      }
                    >
                      <i className="fas fa-reply me-2"></i>
                      Back
                    </button>
                  </OverlayTrigger>
                </div>
                {/* <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="Save">Save</Tooltip>}
                  >
                    <button
                      type="submit"
                      className="btn btn-added"
                      //   disabled={isLoading}
                    >
                 
                      <Save className="me-2" />
                      Update
                    </button>
                  </OverlayTrigger>
                </div> */}
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    {/* <div className="card-header">
                      <h4 className="card-title">Apply Leave Form</h4>
                    </div> */}
                    <div className="card-body">
                      <div className="form-row row">
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-3">
                          <label htmlFor="input-label" className="form-label">
                            Employee
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="input"
                            value={
                              employeeOptions?.find(
                                (item) => item.value === watch("employeeCode"),
                              )?.label
                            }
                            readOnly
                          />
                        </div>

                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-3">
                          <label htmlFor="input-label" className="form-label">
                            Leave Type
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="input"
                            value={
                              leaveTypeOptions?.find(
                                (item) => item.value === watch("leaveCode"),
                              )?.label
                            }
                            readOnly
                          />
                        </div>

                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-3">
                          <label htmlFor="input-label" className="form-label">
                            Request Date
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="input"
                            value={getValues("requestDate")}
                            readOnly
                          />
                        </div>

                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-3">
                          <label htmlFor="input-label" className="form-label">
                            Leave From
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="input"
                            value={getValues("leaveFrom")}
                            readOnly
                          />
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-3">
                          <label htmlFor="input-label" className="form-label">
                            Leave To
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="input"
                            value={getValues("leaveTo")}
                            readOnly
                          />
                        </div>

                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-3">
                          <label htmlFor="input-label" className="form-label">
                            Include Public Holiday
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="input"
                            value={
                              getValues("includePublicHoliday") ? "Yes" : "No"
                            }
                            readOnly
                          />
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-3">
                          <label htmlFor="input-label" className="form-label">
                            No Of Days
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="input"
                            value={getValues("totalDays")}
                            readOnly
                          />
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-3">
                          <label htmlFor="input-label" className="form-label">
                            Reason
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="input"
                            value={getValues("reason")}
                            readOnly
                          />
                        </div>
                        {watch("imageAttachment") && (
                          <div className="col-md-4 col-sg-12 mb-3">
                            <ImagePreview
                              alt="Attachmemt"
                              src={watch("imageAttachment")}
                              className="product-img"
                              width={100}
                              height={100}
                            />
                          </div>
                        )}
                        {watch("pdfAttachment") && (
                          <div className="col-md-4 col-sg-12 mb-3">
                            <label htmlFor="input-label" className="form-label">
                              &nbsp;
                            </label>
                            {/* <button className="btn btn-primary" type="button"> */}
                            <a
                              href={watch("pdfAttachment")}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "white" }}
                              className="btn btn-primary"
                              download
                            >
                              View PDF Attachment
                            </a>
                            {/* </button> */}
                            {/* <div style={{ width: "600px", margin: "auto" }}> */}

                            {/* <Document
                                file={watch("pdfAttachment")} 
                                onLoadSuccess={({ numPages }) =>
                                  setNumPages(numPages)
                                }
                              >
                                {Array.from(
                                  new Array(numPages),
                                  (el, index) => (
                                    <Page
                                      key={index + 1}
                                      pageNumber={index + 1}
                                    />
                                  )
                                )}
                              </Document> */}
                            {/* </div> */}
                          </div>
                        )}
                      </div>
                      <div className="row mt-4">
                        <div className="table-responsive">
                          <Table
                            dataSource={leaveDetails?.[0]?.details || []}
                            columns={columns}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ViewApplyLeave);
